var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 13.6549,
    cy: 13.5412,
    r: 13.0019,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.07956
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1844 21.1672C17.3854 21.1672 20.7971 17.7619 20.7971 13.5609C20.7971 9.35997 17.3854 5.95459 13.1844 5.95459C8.98344 5.95459 5.57812 9.35997 5.57812 13.5609C5.57812 17.7619 8.98344 21.1672 13.1844 21.1672ZM16.1951 16.9535C16.106 17.0935 15.9532 17.1763 15.7941 17.1763C15.705 17.1763 15.6159 17.1508 15.5395 17.0999C13.4135 15.7441 10.0719 16.4952 10.0337 16.5016C9.77907 16.5652 9.52445 16.3997 9.46082 16.1451C9.40353 15.8905 9.56263 15.6296 9.81725 15.5723C9.97002 15.5404 13.5854 14.7194 16.0487 16.2915C16.2715 16.4379 16.3351 16.7307 16.1951 16.9535ZM17.4363 14.923C17.3281 15.0949 17.1499 15.184 16.9653 15.184C16.8634 15.184 16.7616 15.1522 16.6661 15.0949C13.8146 13.2808 9.34627 14.2802 9.30168 14.2929C9.00255 14.3629 8.70338 14.1783 8.63338 13.8792C8.56335 13.58 8.74793 13.2808 9.04707 13.2108C9.25076 13.1599 14.0182 12.0842 17.2644 14.1592C17.5254 14.3247 17.6018 14.6684 17.4363 14.923ZM8.27692 10.843C8.52516 10.7858 14.4511 9.44904 18.4801 12.0205C18.7794 12.2115 18.8685 12.5998 18.6775 12.8989C18.5566 13.0899 18.3529 13.1917 18.1428 13.1917C18.0219 13.1917 17.9073 13.1599 17.7991 13.0962C14.2156 10.8112 8.62064 12.0715 8.56969 12.0842C8.226 12.1669 7.88231 11.9505 7.80591 11.6068C7.72316 11.2694 7.9332 10.9257 8.27692 10.843Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/Spotify.8ddff5c932368c439e60e67dc48b4d46.svg";
export { ForwardRef as ReactComponent };